export function toStartOfDayIso(date: Date): string {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0),
  ).toISOString();
}

export function toEndOfDayIso(date: Date): string {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999,
    ),
  ).toISOString();
}

/** `YYYY-MM-DD` from the local calendar date the user picked (never via UTC). */
export function toDateOnly(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export type RelativeDateRangePreset = 'today' | 'last7Days' | 'last30Days';

const RELATIVE_DATE_RANGE_DAYS_BACK: Record<RelativeDateRangePreset, number> = {
  today: 0,
  last7Days: 6,
  last30Days: 29,
};

export function relativeDateRange(
  preset: RelativeDateRangePreset,
): { startDate: Date; endDate: Date } {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - RELATIVE_DATE_RANGE_DAYS_BACK[preset]);
  return { startDate, endDate };
}
